<template>
  <div class="py-6 px-12 primary elevation-1 d-flex justify-space-between">
      <v-img :src="image_src" class="logo" :contain="true" width="150" max-width="250"></v-img>
      <div v-if="support">
        <span class="header title">
          Éprouvez-vous des difficultés techniques ? <br>
        </span>
        <span class="header text">
          Support technique<br>
          Tous les jours, de 8h00 à 22h00<br>
          Tél.: (418) 948.4848 poste 1<br>
          Tél. sans frais : (866) 843.4848 poste 1<br>
          Support@SVIeSolutions.com
        </span>
      </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      image_src: require("../assets/logo.jpg"),
    };
  },
  computed: {
    support: function() {
      return this.$route.fullPath.includes("/LaraConnexionExterne");
    },
  }
};
</script>

<style>
.header
{
    color: white;
}

.header .title
{
    font-weight: bold;
}
</style>